import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  ArcElement,
  RadialLinearScale,
  ScatterController,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import ChartProp from "../../utils/types/prop.chart";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  ArcElement,
  BarElement,
  RadialLinearScale,
  ScatterController
);

const AppChart: React.FC<ChartProp> = ({ data, options, type }) => {
  return (
      <Chart  type={type} data={data} options={options} />
  );
};

export default AppChart;
